import { c as _taggedTemplateLiteralLoose } from './chunk-eb25cfa0.js';
import { theme, ifProp, withProp, prop } from 'styled-tools';
import { css } from 'styled-components';
import styled from './styled.js';
import 'reuse';
import use from './use.js';
import 'react';
import { bool, number } from 'prop-types';
import './chunk-afcdbe83.js';
import './chunk-1128464e.js';
import Box from './Box.js';
import '@emotion/is-prop-valid';
import s from 'styled-selector';

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var GroupItem = styled(Box)(_templateObject(), theme("GroupItem"));
var GroupItem$1 = use(GroupItem, "div");

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n        border-", "-width: 0;\n        border-", "-radius: 0;\n      "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n        border-top-width: 0;\n        border-top-right-radius: 0;\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["border-", "-radius: 0;"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n        border-bottom-left-radius: 0;\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n        border-", "-width: 0;\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n        border-top-width: 0;\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: ", ";\n  ", ";\n\n  > *:not(:first-child):not(:last-child),\n  > *:not(:first-child):not(:last-child) ", " {\n    border-radius: 0;\n    ", ";\n  }\n\n  > *:first-child,\n  > *:first-child ", " {\n    border-bottom-right-radius: 0;\n    ", ";\n  }\n\n  > *:last-child,\n  > *:last-child ", " {\n    border-top-left-radius: 0;\n    ", ";\n  }\n\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n      @media (min-width: ", "px) {\n        ", ";\n      }\n      @media (max-width: ", "px) {\n        ", ";\n      }\n    "]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var groupItemSelector = s(GroupItem$1);

var verticalAt = function verticalAt(pass, fail) {
  return ifProp("verticalAt", css(_templateObject$1(), withProp("verticalAt", function (x) {
    return x + 1;
  }), fail, prop("verticalAt"), pass), fail);
};

var Group = styled(Box)(_templateObject2(), ifProp("vertical", "column", "row"), verticalAt("flex-direction: column"), groupItemSelector, verticalAt(css(_templateObject3()), css(_templateObject4(), ifProp("vertical", "top", "left"))), groupItemSelector, verticalAt(css(_templateObject5()), css(_templateObject6(), ifProp("vertical", "bottom-left", "top-right"))), groupItemSelector, verticalAt(css(_templateObject7()), css(_templateObject8(), ifProp("vertical", "top", "left"), ifProp("vertical", "top-right", "bottom-left"))), theme("Group")); // @ts-ignore

Group.propTypes = {
  vertical: bool,
  verticalAt: number
};
Group.defaultProps = {
  role: "group"
};
var Group$1 = use(Group, "div");

var index = Object.assign(Group$1, {
  Item: GroupItem$1
});

export default index;
